module.exports = __webpack_public_path__ + "img/penalonen_background_hero.67afb2fe.png";